import React,{Component} from 'react';
//import clsx from 'clsx';
import { withStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import RecordListBody from './Record/RecordListBody'
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Button from '@material-ui/core/Button';
import NotFinishedPage from '../FunctionArea/NotFinishedPage'


  const useStyles = theme => ({
    appBarSpacer: theme.mixins.toolbar,
    content: {
      flexGrow: 1,
      height: '100vh',
      overflow: 'auto',
    },
    container: {
      padding: theme.spacing(1),
    },
    paper: {
      padding: theme.spacing(1),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
    },

    rowPaper: {
      //padding: theme.spacing(1),
      display: 'flex',
      overflow: 'auto',
    },

    fixedHeight: {
      height: '80vh',
    },
    button: {
      margin:theme.spacing(1),
      //padding: theme.spacing(1),
      fontFamily:'Microsoft JhengHei',
    },
    leftIcon: {
      marginRight: theme.spacing(1),
    },
    rightIcon: {
      marginLeft: theme.spacing(1),
    },
    iconSmall: {
      fontSize: 20,
    },
    selectedArea: {
      backgroundColor:"yellow",
      color:"black",
    },
  });

  class RecordManagementBody extends Component {

    constructor(props) {
      super(props)
      this.state = {
        selectedArea:1,
        movieSessionInfo:null
      }
    }

    componentDidMount(){
      console.log("RecordManagementBody did mount")
      if(this.props.userID)
      {
        this.sessionCheck()
      }
      this.props.getCurrentModule("RecordManagement")
      
      window.addEventListener("beforeunload",(e)=>{ 
        e.preventDefault()    
        return this.freeRecordManagementSession()
      })
    }

    componentWillUnmount(){
      window.removeEventListener("beforeunload", this.freeRecordManagementSession())
    }

    sessionCheck=()=>{
    }

    freeRecordManagementSession=()=>{
  
    }

    changeSelectedArea=(index)=>{
      if(this.state.selectedArea !== index)
      {
        this.setState({
          selectedArea:index
        })
      }
    }

    showSessionInfoArea=()=>{
      if(this.state.movieSessionInfo && !this.state.movieSessionInfo.sessionAvaliable)
      {
          let sessionStyle={             
              width:'640px',
              fontSize: 15,
              fontFamily: "Microsoft JhengHei",
              backgroundColor:"red",
              color:"white",
              border:"1px solid",
              borderRadius:"5px",
              padding:"0px 10px 0px 10px",
              margin:"5px"              
          }

          return <div style={sessionStyle}>電影作品資料上下架 <span style={{backgroundColor:"blue",color:"white"}}>{this.state.movieSessionInfo.sessionOccupier}</span>正在操作，您目前僅能檢視，不能變更上下架狀態</div>
      }
      else
      {
          return null
      }
    }

    getMovieSession=(msg)=>{
      if(this.state.movieSessionInfo !== msg)
      {
        this.setState({
          movieSessionInfo:msg
        })
      }
    }

    getMainContainer=()=>{
      if(this.state.selectedArea === 1)
      {
        return <RecordListBody userID={this.props.userID} getMovieSession={this.getMovieSession}/>
      }
      else
      {
        return <NotFinishedPage type={1}/>
      }
    }
  

    render(){
      const {classes} = this.props
      //const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
      //const buttonPaper = clsx(classes.rowPaper);
      //const flexHeightPaper = clsx(classes.paper);

    return (
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <Container maxWidth={false} className={classes.container}>
            <Grid container spacing={1}>
              <Grid item xs={5}>            
                <ButtonGroup variant="contained" aria-label="contained primary button group">
                  <Button className={this.state.selectedArea === 1 ?classes.selectedArea:null} onClick={()=>this.changeSelectedArea(1)}>電影作品資料上下架</Button>
                  <Button className={this.state.selectedArea === 3 ?classes.selectedArea:null} onClick={()=>this.changeSelectedArea(3)}>欄位選擇</Button>
                </ButtonGroup>
              </Grid>         
              <Grid item xs={9}>
                  {this.showSessionInfoArea()}  
              </Grid>
              <Grid item xs={12}>
                <Paper className={classes.paper}>
                  {this.getMainContainer()}
                </Paper>
              </Grid>           
            </Grid>
          </Container>
        </main>
      )
    }
  }

export default withStyles(useStyles)(RecordManagementBody)